import { useEffect, useState } from 'react';

// 计时状态以服务端 started_at 为唯一真相：这里每秒重算「现在 − 开始时间」，
// 不累加本地计数器，所以刷新页面、换设备、休眠唤醒之后显示的都是对的。
export function useElapsedSeconds(startedAt: string | null): number {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!startedAt) {
      setSeconds(0);
      return;
    }

    const startedMs = new Date(startedAt).getTime();
    const recompute = () => setSeconds(Math.max(0, Math.floor((Date.now() - startedMs) / 1000)));

    recompute();
    const timer = window.setInterval(recompute, 1000);
    return () => window.clearInterval(timer);
  }, [startedAt]);

  return seconds;
}

export default useElapsedSeconds;
